// extracted by mini-css-extract-plugin
module.exports = {"root":"DataVisualisationToggle_root__1TUR4","header":"DataVisualisationToggle_header__2RBI3","active":"DataVisualisationToggle_active__2nR5V"};